import { Box, Flex, Group, Image, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { BasicButton, Footer, HeroBackground, Section, SectionText, SectionTitle } from 'components';
import { AppConstants, RouteConstants } from '../../constants';
import classes from './index.module.css';

const { CARD_IMG, NUMBER_OF_CARD_BENEFITS } = AppConstants;
const { ROUTE_CREDIT_CARD_FORM } = RouteConstants;

const CreditCardPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <HeroBackground background={true}>
        <Section hero={true}>
          <Flex justify='space-between' className={classes.wrapper}>
            <Flex className={classes.infoImageBox}>
              <Stack align='flex-start' className={classes.info}>
                <SectionTitle title={t('credit_card.title')} />
                <SectionText text={t('credit_card.descriptions.0')} />
                <SectionText text={t('credit_card.descriptions.1')} />
                <BasicButton onClick={() => navigate(ROUTE_CREDIT_CARD_FORM)} secondary={true}>{t('credit_card.cta')}</BasicButton>
              </Stack>
              <Group align='center' className={classes.cardWrapper}>
                <Image h='auto' w='auto' src={CARD_IMG} />
              </Group>
            </Flex>
            <Stack gap={10}>
              {Array(NUMBER_OF_CARD_BENEFITS).fill(null).map((_, index) => (
                <Box key={index} className={classes.benefit}>
                  <SectionText text={t(`credit_card.benefits.${index}`)} />
                </Box>
              ))}
            </Stack>
          </Flex>
        </Section>
      </HeroBackground>
      <Footer />
    </>
  )
}

export default CreditCardPage;